module.exports = __webpack_public_path__ + "img/9.b5a4341e.jpg";